import * as React from 'react';
import { useAppDispatch } from 'shared/hooks';
import {
  getPrelandingData,
  prelandingToggle,
  setPrelandingId,
  setPrelandingSource,
} from '@cian/frontend-val-my-home-banner';
import { trackBannerClick } from '../containers/ConsultationTrap/tracking';

const CONSULTATION_PRELANDING_ID = 34;

export const usePrelandingProps = () => {
  const dispatch = useAppDispatch();

  const handleBannerClick = React.useCallback(
    async (label: 'CpdConsultationTextLink' | 'CpdConsultationBanner') => {
      trackBannerClick(label);
      dispatch(setPrelandingId(CONSULTATION_PRELANDING_ID));
      // @ts-expect-error: third-party thunk has incompatible dispatch typing
      await dispatch(getPrelandingData({ preLandingId: CONSULTATION_PRELANDING_ID }));
      dispatch(prelandingToggle(true));
      dispatch(setPrelandingSource(`myhome${label}NoObject`));
    },
    [dispatch],
  );

  return {
    handleBannerClick,
  };
};
